import axios from "axios";

const encodeForm = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

export default {
  registerForAccount(userinfo) {
    if (!userinfo) return;
    const {firstName, lastName, email} = userinfo

    return axios
      .post('https://hooks.zapier.com/hooks/catch/6317661/b31q36w/',
        encodeForm({firstName, lastName, email}),
        {headers: {'Accept': 'application/json'}
      })
  },
  firstLogin(userinfo) {
    if (!userinfo) return;
    const {firstName, lastName, email} = userinfo

    return axios
      .post('https://hooks.zapier.com/hooks/catch/6317661/b3xsu9h/',
        encodeForm({firstName, lastName, email}),
        {headers: {'Accept': 'application/json'}
        })
  },
  createFirstSMARTrac(userinfo) {
    if (!userinfo) return;
    const {firstName, lastName, email} = userinfo

    return axios
      .post('https://hooks.zapier.com/hooks/catch/6317661/b3xs6p5/',
        encodeForm({firstName, lastName, email}),
        {headers: {'Accept': 'application/json'}
        })
  },
  addsFirstClient(userinfo) {
    if (!userinfo) return;
    const {firstName, lastName, email} = userinfo

    return axios
      .post('https://hooks.zapier.com/hooks/catch/6317661/b3xsh2y/',
        encodeForm({firstName, lastName, email}),
        {headers: {'Accept': 'application/json'}
        })
  }
}
